import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { FiUsers, FiAward, FiUserX, FiUserCheck, FiStar, FiDollarSign, FiBell } from "react-icons/fi";
import { Link } from 'react-router-dom'; // Import Link from react-router-dom
import axios from "axios";
import "./AdminDashboard.css";

const AdminDashboard = () => {
  const [userCount, setUserCount] = useState(0);
  const [astrologerCount, setAstrologerCount] = useState(0);
  const [registeredUsers, setRegisteredUsers] = useState([]); // Instead of undefined or null
  const [astrologerUsers, setAstrologerUsers] = useState([]);
  const [activeCount, setActiveCount] = useState('0');
  const [submitCount, setSubmitCount] = useState(null);
  const [maleCount, setMaleCount] = useState(0);
  const [femaleCount, setFemaleCount] = useState(0);
  const [featuredCount, setFeaturedCount] = useState(0);
  const [reviewCount, setReviewCount] = useState(0);
  const [successCount, setSuccessCount] = useState(0);
  const [activeUserCount, setActiveUserCount] = useState(0);
  const [suspendedUserCount, setSuspendedUserCount] = useState(0);

  useEffect(() => {
    axios.get('https://back.varankal.com/auth/count-active')
      .then(res => setActiveUserCount(res.data.count))
      .catch(err => console.error('Error fetching active users:', err));

    axios.get('https://back.varankal.com/auth/count-suspended')
      .then(res => setSuspendedUserCount(res.data.count))
      .catch(err => console.error('Error fetching suspended users:', err));
  }, []);
  useEffect(() => {
    async function fetchSuccessCount() {
      try {
        const response = await fetch('https://back.varankal.com/api/success-stories/count/successstories');
        const data = await response.json();
        setSuccessCount(data.count);
      } catch (error) {
        console.error('Error fetching success stories count:', error);
      }
    }
    fetchSuccessCount();
  }, []);
  useEffect(() => {
    async function fetchReviewCount() {
      try {
        const response = await fetch('https://back.varankal.com/api/reviews/count/reviews');
        const data = await response.json();
        setReviewCount(data.count);
      } catch (error) {
        console.error('Error fetching review count:', error);
      }
    }

    fetchReviewCount();
  }, []);

  useEffect(() => {
    axios.get("https://back.varankal.com/user/male-count")
      .then((res) => {
        setMaleCount(res.data.maleCount);
      })
      .catch((err) => {
        console.error("Error fetching male count:", err);
      });

    axios.get("https://back.varankal.com/user/female-count")
      .then((res) => {
        setFemaleCount(res.data.femaleCount);
      })
      .catch((err) => {
        console.error("Error fetching female count:", err);
      });
  }, []);

  useEffect(() => {
    async function fetchFeaturedCount() {
      try {
        const response = await fetch('https://back.varankal.com/auth/count/featured');
        const data = await response.json();
        setFeaturedCount(data.count);
      } catch (error) {
        console.error('Error fetching featured users count:', error);
      }
    }

    fetchFeaturedCount();
  }, []);
  useEffect(() => {
    fetch('https://back.varankal.com/api/payments/active-count')
      .then((res) => res.json())
      .then((data) => {
        if (data.count !== undefined) {
          setActiveCount(data.count.toLocaleString()); // e.g. 8220 => "8,220"
        }
      })
      .catch((err) => {
        console.error('Error fetching active subscription count:', err);
      });
  }, []);

  useEffect(() => {
    // Fetch Registered Users Count
    axios.get("https://back.varankal.com/auth/user-count")
      .then((response) => {
        console.log("Registered Users Count Response:", response.data);
        setUserCount(response.data.count);
      })
      .catch((error) => console.error("Error fetching user count:", error));

    axios.get("https://back.varankal.com/api/astrologers/count")
      .then((response) => {
        console.log("Astrologer Users Count Response:", response.data);
        setAstrologerCount(response.data.count);
      })
      .catch((error) => console.error("Error fetching astrologer count:", error));

    axios.get("https://back.varankal.com/user/get-registered")
      .then((response) => {
        console.log("Registered Users Response:", response.data);
        setRegisteredUsers(response.data.registeredDetails);
      })
      .catch((error) => {
        console.error("Error fetching registered users:", error);
        setRegisteredUsers([]);
      });

    axios.get("https://back.varankal.com/api/astrologers")
      .then((response) => {
        console.log("Astrologer Users List Response:", response.data);
        setAstrologerUsers(response.data);
      })
      .catch((error) => console.error("Error fetching astrologer users:", error));
  }, []);

  useEffect(() => {
    const fetchSubmitCount = async () => {
      try {
        const response = await fetch("https://back.varankal.com/api/submit-request/count");
        const data = await response.json();
        if (data.success) {
          setSubmitCount(data.count);
        } else {
          console.error("Failed to fetch submission count");
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchSubmitCount();
  }, []); // Run only once when the component mounts
  useEffect(() => {
    const fetchRegisteredUsers = async () => {
      try {
        const response = await axios.get('https://back.varankal.com/registered/count');
        setUserCount(response.data.userCount);
        setRegisteredUsers(response.data.registeredDetails || []); // Optional if you use details too
      } catch (error) {
        console.error('Error fetching registered user count:', error);
      }
    };

    fetchRegisteredUsers();
  }, []);

  const stats = [
    { title: "Login Users", count: userCount, icon: <FiUsers />, color: "bg-blue-500" },
    { title: 'Profile Users', count: userCount, icon: <FiUsers />, color: 'bg-green-500', },
    { title: "Male Users", count: maleCount, icon: <FiUserCheck />, color: "bg-blue-700" },
    { title: "Female Users", count: femaleCount, icon: <FiUserCheck />, color: "bg-pink-500" },
    { title: "Featured Profiles", count: featuredCount, icon: <FiUserCheck />, color: "bg-yellow-500" },
    { title: "Astrologer Users", count: astrologerCount, icon: <FiUserCheck />, color: "bg-purple-500" },
    { title: "Active Subscriptions", count: activeCount, icon: <FiDollarSign />, color: "bg-yellow-500" },
    { title: "Active Users", count: activeUserCount, icon: <FiUserCheck size={24} />, color: "bg-green-500" },
    { title: "Suspended Users", count: suspendedUserCount, icon: <FiUserX size={24} />, color: "bg-red-500" },
    {
      title: "Alerts & Reports", count: submitCount, icon: <FiBell />, color: "bg-red-500", isDropdown: true, subLinks: [{ label: "Alert Requests", path: "/admin/request" },
      { label: "Contact Submissions", path: "/admin/contactuslist" }
      ]
    },
    { title: "User Reviews", count: reviewCount, icon: <FiStar />, color: "bg-pink-500" },
    { title: "Success Stories", count: successCount, icon: < FiAward />, color: "bg-pink-500" },
  ];


  return (
    <div className="dashboard-container">
      {/* Header */}
      <motion.div className="dashboard-header" initial={{ opacity: 0, y: -20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>

        <p>Manage and monitor varankal Matrimony user profiles, matches, and activities from your admin dashboard.</p>
      </motion.div>

      <div className="stats-grid">
        {stats.map((stat, index) =>
          stat.isDropdown ? (
            <div className="dropdown-card" key={index}>
              <motion.div
                className={`stat-card ${stat.color}`}
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5, delay: index * 0.2 }}
              >
                <div className="icon">{stat.icon}</div>
                <h2>{stat.count}</h2>
                <p>{stat.title}</p>
              </motion.div>
              <div className="dropdown-links">
                {stat.subLinks.map((link, idx) => (
                  <Link to={link.path} key={idx} className="dropdown-item">
                    {link.label}
                  </Link>
                ))}
              </div>
            </div>
          ) : (
            <motion.div
              key={index}
              className={`stat-card ${stat.color}`}
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5, delay: index * 0.2 }}
            >
              <div className="icon">{stat.icon}</div>
              <h2>{stat.count}</h2>
              <p>{stat.title}</p>
            </motion.div>
          )
        )}
      </div>

      <div className="user-grid">
        <motion.div
          className="user-panel improved-user-panel"
          initial={{ opacity: 0, x: -30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h3 className="user-heading">Recent Registered Users</h3>

          <div className="user-grid-4">
            {registeredUsers.length > 0 ? (
              registeredUsers.map((user, index) => (
                <div className="user-card" key={index}>
                  <p className="user-name">
                    {user.basicDetails?.name || "N/A"}
                  </p>

                  <p className="user-detail">
                    Gender: {user.basicDetails?.gender || "Unknown"}
                  </p>

                  <p className="user-detail">
                    Qualification: {user.basicDetails?.qualification || "N/A"}
                  </p>
                </div>
              ))
            ) : (
              <p className="empty">No recent registered users available.</p>
            )}
          </div>
        </motion.div>
      </div>

    </div>
  );
};

export default AdminDashboard;
